import { useState } from 'react'
import { Form } from 'react-router-dom'

import { Input } from '@/components/ui/input.tsx'
import { Search } from 'lucide-react'

import { useProjectId } from '@/hooks/useProjectId.ts'
import { useSubscription } from '@/hooks/useSubscription.ts'
import { GlobalPubSub } from '@/utils/pubsub.ts'

export const SearchInput = () => {
  const projectId = useProjectId()
  const [searchText, setSearchText] = useState('')

  useSubscription([[GlobalPubSub.Signals.RESET_SEARCH, (() => setSearchText('')) as Callback]])

  return (
    <Form
      className="flex w-[180px] items-center gap-1 p-2 relative bg-surface-secondary rounded-full overflow-hidden focus-within:shadow-[0_0_0_2px_#0b9ff3]"
      onSubmit={(event) => {
        event.preventDefault()
        if (searchText.trim() === '') return
        GlobalPubSub.publish(GlobalPubSub.Signals.SEARCH, { projectId, query: searchText })
      }}
    >
      <Search className="w-6 h-6 text-[#0B9FF3]" />
      <Input
        id="project_search"
        type="text"
        className="flex-1 h-auto p-0 bg-transparent border-none text-contents-onDarkSecondary focus-visible:text-contents-onDarkPrimary font-EN-KR-sub-heading-regular text-[length:var(--EN-KR-sub-heading-regular-font-size)] tracking-[var(--EN-KR-sub-heading-regular-letter-spacing)] leading-[var(--EN-KR-sub-heading-regular-line-height)] focus-visible:ring-0 focus-visible:ring-offset-0"
        value={searchText}
        onKeyDown={(event) => {
          if (event.key === 'Escape') GlobalPubSub.publish(GlobalPubSub.Signals.RESET_SEARCH)
        }}
        onChange={(e) => setSearchText(e.target.value)}
        placeholder="Search..."
      />
    </Form>
  )
}
